module.exports = __webpack_public_path__ + "img/eurojackpot.a5637e51.png";